import { PortalAxiosError } from "../types";

/**
 * Extends the provided Axios error response with errors support
 * @param axiosError
 */
export const extendAxiosError = (axiosError: PortalAxiosError) => {
  return Object.assign(axiosError, {
    getError: () => {
      const errors = axiosError.response?.data.errors;

      if (errors && errors.length > 0) {
        return errors[0];
      }

      return undefined;
    },
    isNetworkError: axiosError.message === "Network Error",
  });
};
